import highchartsVersion from './highchartsVersion';
import filterOptionsForSize from './filterOptionsForSize';
import processData from './processData';
import processCategories from './processCategories';
import processSeries from './processSeries';
import { processStyles } from '../style/';
import merge from 'lodash.merge';
import isPlainObject from 'lodash.isplainobject';

export default function processOptions(options, Highcharts) {
  options = copyOptions(options, Highcharts);
  options = filterOptionsForSize(options);
  options = processData(options);
  options = processCategories(options);
  options.styles = processStyles(options);
  options = processSeries(options);
  options.el = containerElement(options.el);
  return options;
}

function copyOptions(options, Highcharts) {
  return  merge({}, {
    HIGHCHARTS_VERSION: highchartsVersion(Highcharts),
    id: options.el.getAttribute('id') || options.size,
  }, options);
}

// Prepares the container DOM element.
function containerElement(el) {
  el = (typeof el === 'string') ? document.querySelector(el) : el;
  if (!el.querySelector('div.dj-chart-container')) {
    let divA = document.createElement('div');
    let divB = document.createElement('div');
    divA.className = 'dj-chart-container';
    divB.className = 'dj-chart-inner';
    el.appendChild(divA);
    el.appendChild(divB);
  }
  return el;
}



// WEBPACK FOOTER //
// ./src/chart/data/processOptions.js